module.exports = __webpack_public_path__ + "static/media/PaymentsStepInactive.b4321a25.svg";